import axiosInstance from "../func/axiosInstance";

export const verificarSessao= () => {
    return axiosInstance.get('/sessao');
};

export const deletarSessao= () => {
    return axiosInstance.delete('/sessao')
};

export const deletarTodasAsSessoes= () => {
    return axiosInstance.delete('/sessoes')
};


  

